import React from 'react';
import { useComponentRegistry } from '@bem-react/di';
import { cnMessageBar } from '../MessageBar.classname';
import './MessageBar-Close.css';
export var MessageBarClose = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    var Icon = useComponentRegistry(cnMessageBar()).Icon;
    return (React.createElement(Icon, { onClick: onClick, glyph: "type-cross", className: cnMessageBar('Close', null, [className]) }));
};
